import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse
} from "@angular/common/http";
import { environment } from "../../environments/environment";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { HttpErrorHandlerService } from "../core/service/http-error-handler.service";

@Injectable({
  providedIn: "root",
})

export class DataDogLoggerService {
  constructor(
    private http: HttpClient,
    private httpErrorHandler: HttpErrorHandlerService
  ) {
  }

  logDataDogEvent(logLevel:any, message:any, source:any) {

    var idToken = JSON.parse(window.localStorage.getItem("token")||"").id_token;
    const headers = new HttpHeaders()
    .append("appname",environment.appName)
    .set("skip_interceptor", "true")
    .set("skip_interceptor_rum_logs", "true")
    .append("Authorization", "Bearer " + idToken);
    let data = {
      logLevel: logLevel,
      message: message,
      source: source,
      platform:  (window.localStorage.getItem('platform') || 'browser') //ionic_platform
    }
    return this.http.post(`${environment.baseUrl}v1/logging/logDataDogEvent`, data, { headers })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          // Handle special status codes using the error handler service
          if (this.httpErrorHandler.handleHttpError(error)) {
            return throwError(error);
          }
          return throwError(error);
        })
      );
  }



}
